export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["včera"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chat"])}
}